import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthMonitorService {

  #tokenExp: number = 0;

  constructor(private oauthService: OAuthService) {
  }

  public startMonitoring() {
    this.oauthService.events
      .pipe(filter(e => e.type === 'session_terminated'
        || e.type === 'session_error'
        || e.type === 'token_error'
        || e.type === 'token_refresh_error'))
      .subscribe(() => {
        this.notifyParentOfExpiredSession();
        this.oauthService.initLoginFlow();
      });

    setInterval(() => void this.checkTokenAndNotify(), 60 * 1000);
  }

  

  public async checkTokenAndNotify(): Promise<void> {

    if (!this.oauthService.hasValidAccessToken()) {
        if (window.self !== window.top) {
            this.notifyParentOfExpiredSession();
        }
        return;
    }

    // KS, 20260915
    const now: number = Date.now();
    const exp: number = this.oauthService.getAccessTokenExpiration();

    // Schwelle groesser als das Pruefintervall (60s), damit ein gedrosselter Tick das Fenster nicht verpasst
    const threshold: number = 120000;
    const remaining: number = exp - now;

    if (remaining < threshold) {
      try {
        // refreshToken() statt silentRefresh(): entspricht der Config (responseType 'code', useSilentRefresh false)
        // und vermeidet den iframe-Weg ueber silent-refresh.html
        await this.oauthService.refreshToken();
        // erst nach dem aufgeloesten Promise liefert getAccessTokenExpiration() die neue Ablaufzeit
        this.#tokenExp = this.oauthService.getAccessTokenExpiration();
      } catch (error) {
        // der Fehlerfall wird bereits ueber die events-Subscription (token_refresh_error) behandelt
        console.warn('[AuthMonitorService] refreshToken failed', error);
      }
    } else {
      this.#tokenExp = exp;
    }
  }

  private notifyParentOfExpiredSession(): void {
    const message = {
      type: 'auth:session_expired'
    };
    window.parent.postMessage(message, '*');
  }
}